import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyHowzTech from './components/WhyHowzTech';
import Portfolio from './components/Portfolio';
import AIInnovation from './components/AIInnovation';
import Testimonials from './components/Testimonials';
// import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
// import ChatWidget from './components/ChatWidget';


function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <WhyHowzTech />
      <Portfolio />
      <AIInnovation />
      <Testimonials />
      {/* <Blog /> */}
      <Contact />
      <Footer />
      {/* <ChatWidget /> */}
    </div>
  );
}

export default App;
